import { ImageVariant } from './contracts';
import { getCachedImage } from '../../../utils/getCachedImage';

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  variant?: ImageVariant;
  fill?: any;
  priority?: any;
};

export function Image({ variant, ...props }: ImageProps) {
  let src = props.src;
  if (variant && src) {
    // @ts-ignore TODO: fix this type
    const url = props.src?.startsWith('http') ? props.src : `${import.meta.env.VITE_ASSETS_DOMAIN}/${props.src}`;
    src = getCachedImage(url, variant);
  }

  return <img {...props} src={src} />;
}
